<template>
  <button @click="back()"><img src="@/assets/img/back-icon.svg" alt="preview" /></button>
</template>
<script>
export default {
  name: "inc_back",
  props: {},
  watch: {},
  mounted() {},
  methods: {
    back() {
      if (this.$route.path.includes("coach_comment") || this.$route.path.includes("coaching_finish")) {
        // location.href = "/complate_coaching";
        this.$router.replace({ name: "complate_coaching" });
      } else if (this.$route.path.includes("reservation_coaching_view")) {
        location.href = "/reservation_coaching";
      } else {
        history.go(-1);
      }
    },
  },
};
</script>
